import configureStore from './configureStore';

/**
 * Create a store inside this file. Then import this store anywhere it is required
 * Avoid importing this file if not required. Always try to use connect method etc to get store
 */
const store = configureStore();

/**
 * Expose the Redux store on `window` for E2E tests so specs can read/assert state
 * and dispatch actions. Only active when REACT_APP_E2E_TESTING=true.
 */
if (process.env.REACT_APP_E2E_TESTING === 'true') {
    // eslint-disable-next-line no-underscore-dangle
    (window as any).__REDUX_STORE__ = store;
}

export default store;
